module.exports = __webpack_public_path__ + "static/media/navbar-img-3.569bddd6.jpg";